import { FC, PropsWithChildren, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { ManagementSettingsContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/ManagementSettingsContext';
import { defaultContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/ManagementSettingsContext';
import { fetchFrequencyManagementSettings } from 'modules/frequencyManagement/lib/queries/fetchFrequencyManagementSettings';
import { parseFrequencyManagementResponse } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';

export const ManagementSettingsProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { data, isLoading, error, fetch } = useLazyGraphql(fetchFrequencyManagementSettings);

  useEffect(() => {
    fetch();
  }, []);

  const dataLoaded = !isEmpty(data);
  let isReady = false;
  isReady = !isLoading && !error && dataLoaded;
  return (
    <ManagementSettingsContext.Provider
      value={{
        frmManagementSettings: isEmpty(data)
          ? defaultContext.frmManagementSettings
          : parseFrequencyManagementResponse(data),
        isLoading,
        isError: error,
        isReady,
      }}
    >
      {children}
    </ManagementSettingsContext.Provider>
  );
};
